import axios from "axios";
import { constants } from "../../pl_TransactionPage/util/Constants";
import { toast } from "react-toastify";
let { host, uihost } = constants;

export let getPPHIDetail = (enc_data, setState, setPaymentData, setOrder,setLoad) => {
  axios
    .get(`${host}/api/web/getPphiPageData/${enc_data}`)
    .then((res) => {
      let data = res.data;

      setState(data.data);
      setPaymentData(data.payload);
      setOrder(data);
      setLoad(false);
    })
    .catch((error) => {
      window.location.assign(`${uihost}/maintenanceerror`);
      return error;
    });
};

export let payNow = (enc_data, paymentData) => {
  axios
    .post(`${host}/api/web/pphiPayNow/${enc_data}`, paymentData)
    .then((res) => {
      let data = res;
      window.location.assign(data.data.response.links.web_url);
    })
    .catch((error) => {
      window.location.assign(`${uihost}/maintenanceerror`);
      return error;
    });
};

export const sendLink = (enc_data) => {
  return axios
    .post(`${host}/api/web/sendLink/${enc_data}`)
    .then((res) => {
      if (res.data.success) {
        toast.success(res.data.message);
      }
      return res.data;
    })
    .catch((error) => {
      window.location.assign(`${uihost}/maintenanceerror`);
      return error;
    });
};
